import { useEffect } from 'react';
import useCreateEleve from '@teetsh/app/src/queries/eleves/useCreateEleve';
import { useCreateEleveGroup } from '@teetsh/app/src/queries/eleveGroups/useCreateEleveGroup';

export function useAppActions() {
  const createEleve = useCreateEleve();
  const createEleveGroup = useCreateEleveGroup();

  useEffect(() => {
    (window as any).appNoActions = {};
    if ((window as any)?.isPlaywright) {
      (window as any).appActions = (window as any).appActions || {};
      (window as any).appActions.createEleve = createEleve;
      (window as any).appActions.createEleveGroup =
        createEleveGroup.mutateAsync;
    }
  }, []);
}
